{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Selecteer een item",
  "tableResizer": "Resizer",
  "expand": "Expand",
  "collapse": "Collapse",
  "colorSwatchPicker": "Color swatches"
}
